[
	{
		"name": "Maler",
		"keywords": [],
		"link": "/artikler/maler",
		"id": "painter"
	},
	{
		"name": "Rørlegger",
		"keywords": [],
		"link": "/artikler/rørlegger",
		"id": "plumber"
	},
	{
		"name": "Flislegger",
		"keywords": [],
		"link": "/artikler/betong-og-mur",
		"id": "tiler"
	},
	{
		"name": "Betong og mur",
		"keywords": [],
		"link": "/artikler/betong-og-mur",
		"id": "concrete-and-masonry"
	},
	{
		"name": "Elektriker",
		"keywords": [],
		"link": "/artikler/elektriker",
		"id": "electrician"
	},
	{
		"name": "Anleggsgartner",
		"keywords": [],
		"link": "/artikler/anleggsgartner",
		"id": "landscaper"
	},
	{
		"name": "Snekker",
		"keywords": [],
		"link": "/artikler/snekker eller tømrer",
		"id": "joiner"
	},
	{
		"name": "Tømrer",
		"keywords": [],
		"link": "/artikler/snekker eller tømrer",
		"id": "carpenter"
	},
	{
		"name": "Blikkenslager",
		"keywords": [],
		"link": "/artikler/industri-og-blikkenslager",
		"id": "sheet-metal-worker"
	},
	{
		"name": "Maskinentreprenør",
		"keywords": [],
		"link": "/artikler/maskinentreprenør",
		"id": "machine-contractor"
	},
	{
		"name": "Taktekker",
		"keywords": [],
		"link": "/artikler/tektekker",
		"id": "roofer"
	},
	{
		"name": "Vindusvasker",
		"keywords": [],
		"link": "/artikler/vindusvasker",
		"id": "window-washer"
	},
	{
		"name": "Vaktmester",
		"keywords": [],
		"link": "/artikler/vaktmester",
		"id": "caretaker"
	},
	{
		"name": "Renholder",
		"keywords": [],
		"link": "/artikler/renholder",
		"id": "cleaner"
	},
	{
		"name": "Hagearbeid",
		"keywords": [],
		"link": "/artikler/hagearbeid",
		"id": "gardening"
	},
	{
		"name": "Flyttehjelp",
		"keywords": [],
		"link": "/artikler/flyttehjelp",
		"id": "moving-help"
	}
]
